import React from 'react';
import improvingGif from 'assets/images/Improving50x50.gif';

export const RainbowAnimatedIcon: React.FC = () => {
  return (
    <img
      src={improvingGif}
      alt="Rainbow animated icon"
      style={{
        width: 30,
        height: 30,
        display: 'block'
      }}
    />
  );
};
